module.exports = __webpack_public_path__ + "static/media/02ilustracion.e6b217d8.png";